import { render } from "./ViewMediatheque.vue?vue&type=template&id=5af1f0af&scoped=true&ts=true"
import script from "./ViewMediatheque.vue?vue&type=script&lang=ts"
export * from "./ViewMediatheque.vue?vue&type=script&lang=ts"

import "./ViewMediatheque.vue?vue&type=style&index=0&id=5af1f0af&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5af1f0af"]])

export default __exports__